import { ItemTilesCarousel } from '../src/ItemTilesCarousel/ItemTilesCarousel';
export default ItemTilesCarousel;
